import { memo, useEffect, useMemo, useRef, useState } from "react";
import { Radar, Bar, Pie } from "react-chartjs-2";
import { ref, set } from "firebase/database";
import { db } from "../functions/api_firebase";

export const subirDatos = async (cantidadDatos) => {

    const nit = localStorage.getItem("CodigoCliente");
    const razonSocial = localStorage.getItem("RazonSocial");

    if (!nit || !razonSocial) {
        alert("El NIT o la Razón Social no están disponibles en el almacenamiento local.");
        return;
    }

    if (!Array.isArray(cantidadDatos) || cantidadDatos.length === 0) {
        alert("No hay datos para subir.");
        return;
    }

    const fecha = new Date().toISOString();

    const datosAEnviar = {
        Nit: nit,
        RazonSocial: razonSocial,
        Fecha: fecha,
        ...Object.fromEntries(
            cantidadDatos.map(({ modulo, cantidad }) => [modulo, cantidad])
        )
    };

    set(ref(db, `informe/${nit}`), datosAEnviar)
        .then(() => alert("Datos subidos exitosamente."))
        .catch((error) => {
            console.error("Error al subir los datos:", error);
            alert("Hubo un error al subir los datos.");
        });

};


export const agregarRazonSocial = (codigo, respuesta) => {
    let nombre;
    let servicio;
    let estado;
    switch (codigo) {
        case '800236506':
            nombre = 'CENTRO COMERCIAL EL PASO';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '816003057':
            nombre = 'CONDOMINIO MONTEVERDE PROPIEDAD HORIZONTAL';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '830058344':
            nombre = 'QUINTAS DE SANTA BARBARA 7 ETAPA 1';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '830061464':
            nombre = 'CONJUNTO RESIDENCIAL PLAZUELA DE SAN ESTEBAN P.H';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '891411226':
            nombre = 'UNIDAD RESIDENCIAL BARRIO OLIMPICO MANZANAS 28 Y 31 P. H.';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '891480071':
            nombre = 'SOCIEDAD DE MEJORAS: PARQUES LA CIRCUNVALAR';
            servicio = 'Rondas';
            estado = 'Desactivado';
            break;
        case '900039203':
            nombre = 'CONJUNTO RESIDENCIAL ALTOS DE TANAMBI PROPIEDAD HORIZONTAL';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900093515':
            nombre = 'SANTA JUANA DE LAS VILLAS';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '900222277':
            nombre = 'CONJUNTO RESIDENCIAL VILLAS DE HATO CHICO II PROPIEDAD HORIZONTAL';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900297836':
            nombre = 'CONJUNTO RESIDENCIAL BULEVAR DEL CAFÉ P.H';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900362633':
            nombre = 'COORDINAR SEGURIDAD Y COMPAÑÍA LTDA';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900405228':
            nombre = 'UKUMARI';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900443785':
            nombre = 'EL NOGAL CLUB RESIDENCIAL P.H.';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900446797':
            nombre = 'Condominio Las Marías P.H';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900548837':
            nombre = 'CONJUNTO 1 BOSQUES DE CUBA - PROPIEDAD HORIZONTAL';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900666808':
            nombre = 'CONJUNTO RESIDENCIAL LA ESTANCIA';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900683091':
            nombre = 'CONJUNTO RESIDENCIAL VILLAS DE LA MERCED PROPIEDAD HORIZONTAL';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900900284':
            nombre = 'CONJUNTO RESIDENCIAL BALCONES DE VILLA VERDE P.H';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '900936920':
            nombre = 'MALABAR RESERVADO CONDOMINIO RESIDENCIAL CAMPESTRE PH';
            servicio = 'Rondas';
            estado = 'Desactivado';
            break;
        case '900962373':
            nombre = 'CONJUNTO RESIDENCIAL NORMANDIA PARQUE PH';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '901008104':
            nombre = 'EDIFICIO LA CANDELARIA PH';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901029787':
            nombre = 'CONJUNTO RESIDENCIAL BAMBU P.H.';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901092699':
            nombre = 'CONJUNTO CERRADO PARQUE JARDÍN P.H';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '901121019':
            nombre = 'CONDOMINIO CAMPESTRE VERDE ORIENTE - P.H';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '901127791':
            nombre = 'CONJUNTO RESIDENCIAL SAVANNAH APARTAMENTOS - PROPIEDAD HORIZONTAL';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901137294':
            nombre = 'CONJUNTO RESIDENCIAL CEDRO NEGRO CLUB HOUSE P.H.';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '901296430':
            nombre = 'CONJUNTO RESIDENCIAL TORRES DE ALEJANDRIA PH';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901507838':
            nombre = 'ENTRE RIOS CONJUNTO RESIDENCIAL PH';
            servicio = 'Rondas';
            estado = 'Desactivado';
            break;
        case '901547438':
            nombre = 'CONJUNTO RESIDENCIAL LA QUINTA CLUB HOUSE P.H';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901727734':
            nombre = 'CONJUNTO DE USO MIXTO CEREZO DE NOVATERRA P.H';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '901747617':
            nombre = 'CONJUNTO RESIDENCIAL SOLARUM - PROPIEDAD HORIZONTAL';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901749545':
            nombre = 'CONJUNTO RESIDENCIAL OLMO';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '8914800714':
            nombre = 'SOCIEDAD DE MEJORAS: PARQUEADERO MATECAÑA';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900224184':
            nombre = 'CONJUNTO RESIDENCIAL CAMPESTRE QUINTAS DE ALEJANDRIA P.H.';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900442933':
            nombre = 'SCRIBE COLOMBIA S.A';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '901505941':
            nombre = 'CONJUNTO RESIDENCIAL Y COMERCIAL CAÑA DULCE P.H';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '891401711':
            nombre = 'MAGNETRON';
            servicio = 'Todo';
            estado = 'Desactivado';
            break;
        case '901740223':
            nombre = 'CONJUNTO RESIDENCIAL BOSQUES DE BAMBU - PROPIEDAD HORIZONTAL';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '900477670':
            nombre = 'EDIFICIO TORRES DE SAN RAFAEL';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '900384164':
            nombre = 'ALAMEDA DE SAN PATRICIO PH';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '901138925':
            nombre = 'CONDOMINIO LA TRINIDAD LIVING FARM PH';
            servicio = 'Todo';
            estado = 'Activo';
            break;
        case '901466557':
            nombre = 'EDIFICIO URBAN';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '830086602':
            nombre = 'CONJUNTO MULTIFAMILIAR COMPARTIR BOCHICA V ETAPA - PROPIEDAD HORIZONTAL';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        case '901767334':
            nombre = 'ACC CONSULTORES Y GESTIÓN INMOBILIARIA S.A.S';
            servicio = 'Rondas';
            estado = 'Activo';
            break;
        default:
            nombre = 'Sin nombre';
            servicio = 'Sin producto';
            estado = 'Sin estado';
            break;
    }

    switch (respuesta) {
        case "nombre":
            return nombre;
        case "producto":
            return servicio;
        case "estado":
            return estado;
        default:
            break;
    }
};


const LIMITE_ETIQUETAS = 40;

const CHART_COMPONENTS = {
  radar: Radar,
  barra: Bar,
  pastel: Pie
};

const useCercaDelViewport = (referencia) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return;

    const elemento = referencia.current;
    if (!elemento) return;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }

    const observador = new IntersectionObserver(
      (entradas) => {
        if (entradas.some((entrada) => entrada.isIntersecting)) {
          setVisible(true);
          observador.disconnect();
        }
      },
      { rootMargin: "400px" }
    );

    observador.observe(elemento);
    return () => observador.disconnect();
  }, [referencia, visible]);

  return visible;
};

const Grafica = memo(function Grafica({
  tipoGrafica, titulo, datos, alto, ancho, tipo, graficaMostrar, datosMostrar
}) {
  const contenedor = useRef(null);
  const visible = useCercaDelViewport(contenedor);

  const { clavesOrdenadas, data, options } = useMemo(() => {
    const claves = Object.keys(datos || {});
    const ordenadas = tipo === "texto"
      ? claves.sort()
      : claves.sort((a, b) => Number(a) - Number(b));
    const valores = ordenadas.map((clave) => datos[clave]);

    const serieLarga = ordenadas.length > LIMITE_ETIQUETAS;

    const datasets = [{
      label: titulo,
      data: valores,
      backgroundColor: 'rgba(255, 71, 71, 0.2)',
      borderColor: 'rgba(255, 71, 71, 1)',
      borderWidth: 1,
      datalabels: {
        display: !serieLarga,
        anchor: 'end',
        align: 'top',
        formatter: (value) => value,
      }
    }];

    if (tipoGrafica === "barra") {
      datasets.push({
        label: "Linea de Tendencia",
        data: valores,
        backgroundColor: "rgba(234, 87, 102, 0.6)",
        borderColor: "rgba(234, 87, 102, 0.6)",
        fill: false,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 5,
        pointRadius: serieLarga ? 0 : 3,
        type: "line",
        order: 0,
        datalabels: { display: false }
      });
    }

    return {
      clavesOrdenadas: ordenadas,
      data: { labels: ordenadas, datasets },
      options: {
        maintainAspectRatio: false,
        normalized: true,
        animation: serieLarga ? false : undefined,
        plugins: {
          datalabels: { display: !serieLarga }
        }
      }
    };
  }, [datos, titulo, tipo, tipoGrafica]);

  const ChartComponent = CHART_COMPONENTS[tipoGrafica];
  if (!ChartComponent) return <p>Gráfica no encontrada</p>;

  return (
    <div>
      {graficaMostrar && clavesOrdenadas.length > 0 && (
        <div
          ref={contenedor}
          style={{ width: `${ancho}px`, height: `${alto}px`, margin: '0 auto' }}
        >
          {visible && <ChartComponent data={data} options={options} />}
        </div>
      )}

      {datosMostrar && (
        <div className="ListadoInmuebles" style={{ marginTop: 16, marginBottom: 24 }}>
          <table id="table" className="tabla-responsive">
            <thead>
              <tr>
                <th>Descripción</th>
                <th>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              {clavesOrdenadas.map((clave, index) => (
                <tr key={index}>
                  <td>{clave}</td>
                  <td>{datos[clave]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
});

export const crearGrafica = (tipoGrafica, titulo, datos, alto, ancho, tipo, graficaMostrar, datosMostrar) => (
  <Grafica
    tipoGrafica={tipoGrafica}
    titulo={titulo}
    datos={datos}
    alto={alto}
    ancho={ancho}
    tipo={tipo}
    graficaMostrar={graficaMostrar}
    datosMostrar={datosMostrar}
  />
);


export const crearTitulo = (titulo) => {
    return (
        <div style={{ marginBottom: 16, marginTop: 8 }}>
            <p style={{
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: '#c0392b',
                margin: 0,
                paddingBottom: 6,
                borderBottom: '2px solid #c0392b',
                display: 'inline-block'
            }}>{titulo}</p>
        </div>
    );
};

const parsearRangoEdad = (rango) => {
  const limpio = rango
    .replace(/años/gi, '')
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, '')
    .trim();

  if (limpio.includes('-')) {
    const partes = limpio.split('-').map(Number);
    if (partes.length === 2 && !isNaN(partes[0]) && !isNaN(partes[1]) && partes[0] > 0 && partes[1] > 0) {
      return (partes[0] + partes[1]) / 2;
    }
  }

  if (limpio.toLowerCase().includes('a')) {
    const partes = limpio.toLowerCase().split('a').map(Number);
    if (partes.length === 2 && !isNaN(partes[0]) && !isNaN(partes[1])) {
      return (partes[0] + partes[1]) / 2;
    }
  }

  const num = parseFloat(limpio.replace(/[^0-9.]/g, ''));
  return isNaN(num) ? null : num;
};

export const crearGraficaPercentilesEdad = (rangoEdad, graficaMostrar, datosMostrar) => {
  const valoresExpandidos = [];

  Object.entries(rangoEdad).forEach(([rango, cantidad]) => {
    const valorMedio = parsearRangoEdad(rango);
    if (valorMedio !== null && valorMedio > 0) {
      for (let i = 0; i < cantidad; i++) valoresExpandidos.push(valorMedio);
    }
  });

  if (valoresExpandidos.length === 0) return null;

  const n = valoresExpandidos.length;
  const media = valoresExpandidos.reduce((a, b) => a + b, 0) / n;
  const desviacion = Math.sqrt(
    valoresExpandidos.reduce((sum, v) => sum + Math.pow(v - media, 2), 0) / n
  );

  const puntos = 200;
  const minX = Math.max(0, media - 4 * desviacion);
  const maxX = media + 4 * desviacion;
  const paso = (maxX - minX) / puntos;

  const gaussiana = (x, mu, sigma) =>
    (1 / (sigma * Math.sqrt(2 * Math.PI))) *
    Math.exp(-0.5 * Math.pow((x - mu) / sigma, 2));

  const labels = [];
  const dataCurva = [];
  for (let i = 0; i <= puntos; i++) {
    const x = minX + i * paso;
    labels.push(x.toFixed(1));
    dataCurva.push(gaussiana(x, media, desviacion));
  }

  valoresExpandidos.sort((a, b) => a - b);

  const getPercentil = (p) => {
    const idx = Math.ceil((p / 100) * n) - 1;
    return valoresExpandidos[Math.max(0, idx)];
  };

  const percentilesConfig = [
    { p: 10, color: 'rgba(54, 162, 235, 0.9)'  },
    { p: 25, color: 'rgba(75, 192, 192, 0.9)'  },
    { p: 50, color: 'rgba(255, 99, 132, 0.9)'  },
    { p: 75, color: 'rgba(75, 192, 192, 0.9)'  },
    { p: 90, color: 'rgba(54, 162, 235, 0.9)'  },
  ];

  const datasetsPercentiles = percentilesConfig.map(({ p, color }) => {
    const valorP = getPercentil(p);

    const verticalData = labels.map((label) => {
      const x = parseFloat(label);
      return Math.abs(x - valorP) <= paso * 1.2 ? gaussiana(x, media, desviacion) : null;
    });

    return {
      label: `P${p} = ${valorP.toFixed(0)} años`,
      data: verticalData,
      borderColor: color,
      backgroundColor: color,
      borderWidth: 2.5,
      borderDash: [6, 4],
      pointRadius: 0,
      fill: false,
      spanGaps: false,
      type: 'line',
      datalabels: { display: false },
    };
  });

  const datasets = [
    {
      label: 'Distribución de Edad',
      data: dataCurva,
      borderColor: 'rgba(255, 71, 71, 1)',
      backgroundColor: 'rgba(255, 71, 71, 0.15)',
      fill: true,
      tension: 0.4,
      pointRadius: 0,
      borderWidth: 2,
      datalabels: { display: false },
    },
    ...datasetsPercentiles,
  ];

  const todosPercentiles = [5, 10, 25, 50, 75, 90, 95];

  return (
    <div>
      {graficaMostrar && (
        <div style={{ width: '1300px', height: '600px', margin: '0 auto' }}>
          <Bar
            data={{ labels, datasets }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: { display: true, position: 'top' },
                datalabels: { display: false },
                tooltip: {
                  callbacks: {
                    title: (items) => `Edad: ${parseFloat(items[0].label).toFixed(0)} años`,
                    label: (item) =>
                      item.dataset.label === 'Distribución de Edad'
                        ? `Densidad: ${item.raw.toFixed(5)}`
                        : item.dataset.label,
                  },
                },
              },
              scales: {
                x: {
                  title: { display: true, text: 'Edad (años)' },
                  ticks: {
                    maxTicksLimit: 12,
                    callback: (_, i) => {
                      const val = parseFloat(labels[i]);
                      return Number.isInteger(Math.round(val)) ? `${Math.round(val)}` : null;
                    },
                  },
                },
                y: {
                  title: { display: true, text: 'Densidad de probabilidad' },
                  ticks: { display: false },
                },
              },
            }}
          />
        </div>
      )}

      {datosMostrar && (
        <table id="table" className="tabla-responsive">
          <thead>
            <tr>
              <th>Percentil</th>
              <th>Edad estimada</th>
            </tr>
          </thead>
          <tbody>
            {todosPercentiles.map((p) => (
              <tr key={p}>
                <td>P{p}</td>
                <td>{getPercentil(p).toFixed(0)} años</td>
              </tr>
            ))}
            <tr style={{ fontWeight: 'bold' }}>
              <td>Media</td>
              <td>{media.toFixed(1)} años</td>
            </tr>
            <tr style={{ fontWeight: 'bold' }}>
              <td>Desviación estándar</td>
              <td>{desviacion.toFixed(1)} años</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export const tablaUsabilidad = (informes, condicion, estado) => {
    return (
        <table id="table" className="tabla-responsive">
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Razón Social</th>
                    <th>Nit</th>
                    <th>Servicio</th>
                    <th>Noticias</th>
                    <th>Visitantes</th>
                    <th>Eventos</th>
                    <th>Encomiendas</th>
                    <th>Reservas</th>
                    <th>Pqrs</th>
                    <th>Anuncios</th>
                    <th>Notificaciones</th>
                    <th>Novedades</th>
                    <th>Rondas</th>
                    <th>Casas</th>
                    <th>Usuarios</th>
                    <th>Estado</th>
                </tr>
            </thead>
            <tbody>
                {Object.values(informes)
                    .filter((item) =>
                        estado === "Desactivado"
                            ? agregarRazonSocial(item.Nit, "estado") === estado
                            : agregarRazonSocial(item.Nit, "producto") === condicion &&
                              agregarRazonSocial(item.Nit, "estado") === estado
                    )
                    .map((item, index) => (
                        <tr key={index}>
                            <td>{item.Fecha.substring(0, 10)}</td>
                            <td>{item.RazonSocial.toUpperCase()}</td>
                            <td>{item.Nit}</td>
                            <td>{agregarRazonSocial(item.Nit, "producto")}</td>
                            <td>{item.Noticias}</td>
                            <td>{item.Visitantes}</td>
                            <td>{item.Eventos}</td>
                            <td>{item.Encomiendas}</td>
                            <td>{item.Reservas}</td>
                            <td>{item.Pqrs}</td>
                            <td>{item.Anuncios}</td>
                            <td>{item.Notificaciones}</td>
                            <td>{item.Novedades}</td>
                            <td>{item.Rondas}</td>
                            <td>{item.Casas}</td>
                            <td>{item.Usuarios}</td>
                            <td>{agregarRazonSocial(item.Nit, "estado")}</td>
                        </tr>
                    ))}
            </tbody>
        </table>
    );
};